import apiSlice from "./apiSlice";
const milestonePackagesSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllMilestoneList: builder.query({
      query: (req) => ({
        url: `milestone`,
        params: req,
      }),
      providesTags: ["AllMilestoneList"],
      refetchOnMountOrArgChange: true,
    }),
    getMilestoneDetail: builder.query({
      query: (req) => ({
        url: `milestone/${req}`,
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
    }),
  }),
});

export const { useGetAllMilestoneListQuery, useGetMilestoneDetailQuery } = milestonePackagesSlice;
